import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'WinnersNoAuth',
            headers: {},
            args: {},
            urlArgs: {
                drawing_id: payload.drawing_id,
            },
        });
        return result;
    };
};
